import React from "react"

import { Redirect } from "react-router-dom"
import { gql, useQuery } from "urql"

import { WithLoadingIndicator } from "~tailwindui/Basics"

import AudioRoom from "components/AudioRoom"

const TeacherAudioRoomPage = () => {
  const [result] = useQuery({ query: airClassroomRoomQuery })

  return (
    <WithLoadingIndicator result={result}>
      {({ data: { viewer } }) =>
        viewer.audioRoom ? (
          <AudioRoom
            audioRoomId={viewer.audioRoom.id}
            currentUserId={viewer.id}
            userType="Teacher"
          />
        ) : (
          <Redirect to="/air-classrooms" />
        )
      }
    </WithLoadingIndicator>
  )
}

const airClassroomRoomQuery = gql`
  query TeacherAirClassroomRoom {
    viewer {
      id
      audioRoom {
        id
      }
    }
  }
`

export default TeacherAudioRoomPage
